import React, { FC, useEffect, useState } from "react";
import { useSetAtom } from "jotai";
import { Icon } from "assets/icons";
import { setModalCloseAtom } from "atoms/modalAtom/modalAtom";
import { useEmployeesState } from "atoms/employeesAtom";
import { useGetEmployeesGroups } from "shared-apis/api";
import { EmloyeesGroup } from "types";

import { Button, EButtonVariant } from "components/Button/Button";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";
import Radio from "components/Radio/Radio";
import { BaseLayout } from "components/BaseLayout/BaseLayout";
import { BoldText } from "components/BoldText/BoldText";

import { useReassignWorker } from "../api";

export const AssignEmployeeModal: FC = () => {
  const [selectedRadio, setSelectedRadio] = useState<string | null>(null);
  const closeModal = useSetAtom(setModalCloseAtom);
  const { employeesState } = useEmployeesState();

  const { data: employeesGroups = [] } = useGetEmployeesGroups({
    enabled: false,
  });

  const { mutate: reassignEmployee } = useReassignWorker();

  const handleSave = () => {
    if (selectedRadio) {
      reassignEmployee({
        usersgroupid: selectedRadio,
        usersid: employeesState.activeItem?.usersid || "",
      });
    }

    closeModal();
  };

  useEffect(() => {
    if (employeesState.activeItem && !selectedRadio) {
      setSelectedRadio(employeesState.activeItem.usersgroupid || null);
    }
  }, [employeesState.activeItem, selectedRadio]);

  return (
    <BaseLayout
      width={400}
      height={500}
      header={
        <div className="flex justify-between items-center">
          <BoldText>Назначить на должность</BoldText>
          <Icon type="close" onClick={closeModal} className="cursor-pointer" />
        </div>
      }
      footer={
        <div className="flex flex-row justify-center">
          <Button onClick={closeModal} variant={EButtonVariant.TERTIARY}>
            Отменить
          </Button>
          <HorizontalSpace size={5} />
          <Button variant={EButtonVariant.SECONDARY} onClick={handleSave}>
            Назначить
          </Button>
        </div>
      }
    >
      <div style={{ padding: 32 }}>
        {employeesGroups.map(({ item }: EmloyeesGroup) => (
          <div
            className="items-center justify-end w-45 mb-2"
            key={item.usersgroupid}
          >
            <Radio
              id={item.usersgroupid}
              text={item.name}
              name="itemGroup"
              onChange={() => setSelectedRadio(item.usersgroupid)}
              checked={selectedRadio === item.usersgroupid}
              value={item.usersgroupid}
            />
          </div>
        ))}
      </div>
    </BaseLayout>
  );
};
